import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import type { QueryClient } from "react-query";

import { queryPersistOptions } from "./persistQueryClient";
import { queryClient as defaultQueryClient } from "./reactQueryConfig";

export interface QueryClientProviderProps {
  children: React.ReactNode;
  client?: QueryClient;
}

export const QueryClientProvider = ({
  children,
  client = defaultQueryClient,
}: QueryClientProviderProps) => (
  <PersistQueryClientProvider
    client={client}
    persistOptions={queryPersistOptions}
  >
    {children}
  </PersistQueryClientProvider>
);

/* eslint-disable-next-line no-barrel-files/no-barrel-files -- js to ts conversion */
export * from "./reactQueryConfig";
